import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import API from '../../../services/API'
import AssignShiftComponent from './AssignShiftComponent'
import { PTSDutiesContext } from '.'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import EventIcon from '@mui/icons-material/Event'
import { Autocomplete, Chip, LinearProgress, TextField } from '@mui/material'

const UnassignedShifts = () => {
  const {
    loading,
    duties,
    unassignedShifts,
    getUnassignedShifts,
    setCreateModalOpen,
    reloadDuty,
    setShiftsWithoutDuty,
  } = useContext(PTSDutiesContext)
  const [assignShiftOpen, setAssignShiftOpen] = useState(null)
  const [selectedDuty, setSelectedDuty] = useState(null)

  const handleAssignDuty = () => {
    API.post('/pts/shifts/assign-shift-to-duty', {
      shift: assignShiftOpen._id,
      ptsDuty: selectedDuty._id,
    })
      .then((res) => {
        if (res.status === 200) {
          reloadDuty()
          setAssignShiftOpen(null)
        }
      })
      .then(() => {
        getUnassignedShifts()
        setShiftsWithoutDuty((prev) =>
          prev.filter((x) => x._id !== assignShiftOpen._id),
        )
      })
  }

  return (
    <Box
      bgcolor="#fff"
      p={2}
      borderRadius={2}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <EventIcon color="anBlue" />
        <Typography variant="subtitle1" fontWeight={600} color="anBlue.main">
          Shifts not allocated to a Duty
        </Typography>
      </Stack>

      <Box sx={{ flex: 1, overflowY: 'auto', pr: 1 }}>
        {loading ? (
          <Box textAlign="center" mt={4}>
            <LinearProgress size={24} />
          </Box>
        ) : unassignedShifts.length ? (
          unassignedShifts.map((us) => (
            <AssignShiftComponent
              shift={us}
              key={us._id}
              onClick={() => setAssignShiftOpen(us)}
            />
          ))
        ) : (
          <Typography
            variant="body2"
            color="text.secondary"
            textAlign="center"
            mt={2}
          >
            All shifts assigned to a Duty
          </Typography>
        )}
      </Box>
      <Dialog
        fullWidth
        open={!!assignShiftOpen}
        onClose={() => setAssignShiftOpen(null)}
      >
        <Stack padding={1.5} gap={1} alignItems="center">
          <Typography variant="title2" fontSize="1.2rem">
            Assign Shift to Duty
          </Typography>
          {duties.length ? (
            <>
              <Typography variant="body2" mb={1}>
                Choose a duty to assign this <b>SHIFT</b> to:
              </Typography>
              <Autocomplete
                options={duties}
                value={selectedDuty}
                onChange={(e, newValue) => setSelectedDuty(newValue)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select a duty" />
                )}
                fullWidth
                getOptionKey={(opt) => opt._id}
                isOptionEqualToValue={(opt, val) => opt._id === val._id}
                getOptionLabel={(opt) =>
                  `${opt.vehicle.callSign} | ${moment(opt.start).format(
                    'Do MMM YY HH:mm',
                  )} - ${moment(opt.end).format(moment(opt.start).isSame(opt.end, 'day') ? 'HH:mm' : 'Do MMM YY HH:mm')}`
                }
                renderOption={(props, opt) => (
                  <Typography component="li" {...props} key={opt._id}>
                    <strong style={{ color: 'contrast.main' }}>
                      {opt.vehicle.callSign}
                    </strong>{' '}
                    |{' '}
                    {`${moment(opt.start).format(
                      'Do MMM YY HH:mm',
                    )} - ${moment(opt.end).format(moment(opt.start).isSame(opt.end, 'day') ? 'HH:mm' : 'Do MMM YY HH:mm')}`}
                  </Typography>
                )}
              />
              <Button
                onClick={() => {
                  handleAssignDuty()
                }}
                fullWidth
                variant="contained"
                color="anBlue"
                disabled={!selectedDuty}
              >
                Submit
              </Button>
            </>
          ) : (
            <>
              <Typography variant="body2" mb={1}>
                There are no Duties for this date yet.
              </Typography>
              <Button
                onClick={() => {
                  setCreateModalOpen(true)
                  setAssignShiftOpen(null)
                }}
                fullWidth
                variant="contained"
                color="anBlue"
              >
                Create a Duty
              </Button>
            </>
          )}
        </Stack>
      </Dialog>
    </Box>
  )
}

export default UnassignedShifts
